export default "__VITE_ASSET__Dornzl2l__"